/* eslint-disable no-prototype-builtins */
import { isEmpty } from 'lodash';
import { PAD_VISIT_TYPE } from 'app/config/padVisits';
import { USER_TYPE } from 'app/config/users';
import { VISITATION_TYPE_TEMPLATE } from 'app/config/visitationTypeTemplate';

const TEMPLATE_NAME = 'INITIALIZE_PAD';

const updateAutomaticRepeat = (cPadVisit, genericVisit) => {
  return genericVisit.map(visit => {
    const { padVisit } = visit;

    if (padVisit.id === cPadVisit.id) {
      // visit.events = [];
      visit.automaticRepeat = !visit.automaticRepeat;

      return visit;
    } else {
      return visit;
    }
  });
};

const updateScheduledMaximumVisits = (cPadVisit, genericVisit, isMaximumVisitsScheduled) => {
  return genericVisit.map(visit => {
    const { padVisit } = visit;

    if (padVisit.id === cPadVisit.id) {
      visit.isMaximumVisitsScheduled = isMaximumVisitsScheduled;

      return visit;
    } else {
      return visit;
    }
  });
};

/**
 * This function builds the initial array of data selected ti client.
 *
 */
const initialArrayOfClientVisits = pad => {
  const padVisits = pad.padVisits;
  const genericVisit = [];
  const suspensionVisits = [];
  const scheduleImplantation = {};

  // eslint-disable-next-line no-unused-vars
  for (const padVisit of padVisits) {
    const CLIENT_RESPONSABILITY = USER_TYPE.HOMECARE;
    const { responsibleType, visitationType, padVisitType, previousEvents } = padVisit;

    const visitationTypeTemplate = visitationType.visitationTypeTemplate;

    const isPadVisitSuspension = padVisitType === PAD_VISIT_TYPE.SUSPENSION;
    const isResponsibleClient = responsibleType === CLIENT_RESPONSABILITY;
    const visitTypeId = visitationTypeTemplate.id;
    const isImplantationVisit = visitTypeId === VISITATION_TYPE_TEMPLATE.IMPLANTATION;

    if (!isPadVisitSuspension) {
      //
      if (isResponsibleClient && !isImplantationVisit) {
        genericVisit.push({
          padVisit,
          previousEvents,
          events: [],
          automaticRepeat: false,
          isMaximumVisitsScheduled: false
        });
      }
    } else {
      //
      suspensionVisits.push({ padVisitId: padVisit.id });
    }

    if (isResponsibleClient && isImplantationVisit) {
      scheduleImplantation.padVisit = padVisit;
      scheduleImplantation.events = [];
    }
  }

  return { scheduleImplantation, genericVisit, suspensionVisits };
};
const initialArrayOfClientPrescriptions = pad => {
  const { padPrescriptions } = pad;

  let schedulePrescriptions = [];

  // eslint-disable-next-line no-unused-vars
  for (const padPrescription of padPrescriptions) {
    // const { id, startDateTime, instruction, description } = padPrescription;

    schedulePrescriptions.push({ ...padPrescription });
  }

  return schedulePrescriptions;
};

/**
 * This function builds the initial array of data selected ti client.
 *
 */
const initialArrayOfCooperativeVisits = padVisit => {
  const genericVisit = [];
  const suspensionVisits = [];

  // eslint-disable-next-line no-unused-vars
  const COOPERATIVE_RESPONSABILITY = USER_TYPE.COOPERATIVE;
  const { padVisitType, responsibleType, previousEvents } = padVisit;

  const isPadVisitSuspension = padVisitType === PAD_VISIT_TYPE.SUSPENSION;

  if (!responsibleType) {
    return { genericVisit, suspensionVisits };
  }

  const isResponsibleCooperative = responsibleType === COOPERATIVE_RESPONSABILITY;

  if (!isPadVisitSuspension) {
    //
    if (isResponsibleCooperative) {
      genericVisit.push({
        padVisit,
        previousEvents,
        events: [],
        automaticRepeat: false,
        isMaximumVisitsScheduled: false
      });
    }
  } else {
    //
    suspensionVisits.push({ padVisitId: padVisit.id });
  }

  return { genericVisit, suspensionVisits };
};

const initialState = () => ({
  loading: false,
  isSubmitting: false,
  padVisitId: null,
  padVisit: {},
  pad: {},
  steps: [],

  selectedData: {
    scheduleImplantation: {
      events: [],
      padVisit: {}
    },
    hospitalReleasePrevision: '',
    dischargePatient: {
      releaseDate: null,
      releaseReasonDescription: null,
      deathReleaseSignal: null
    },
    scheduleVisits: {
      genericVisit: []
    },
    schedulePrescriptions: [],
    suspensionVisits: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_CLIENT_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_CLIENT_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    // REFACTOR modificar nome da propriedade selectedData para screenSteps, pois esse objeto representa os dados que cada tela precisa
    // stepScreenData
    case `${TEMPLATE_NAME}_CLIENT_FULFILLED`: {
      const newData = action.payload;
      const { genericVisit, scheduleImplantation, suspensionVisits } =
        initialArrayOfClientVisits(newData);

      const schedulePrescriptions = initialArrayOfClientPrescriptions(newData);

      return {
        ...state,
        loading: false,
        pad: newData,

        selectedData: {
          scheduleImplantation,
          hospitalReleasePrevision: newData.hospitalReleasePrevision,
          dischargePatient: {
            ...state.selectedData.dischargePatient
          },
          scheduleVisits: {
            genericVisit
          },
          schedulePrescriptions,
          suspensionVisits
        }
      };
    }

    case `${TEMPLATE_NAME}_COOPERATIVE_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_COOPERATIVE_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_COOPERATIVE_FULFILLED`: {
      const newData = action.payload;
      const padVisit = newData;
      const padVisitId = padVisit.id;
      const pad = padVisit.pad;
      const { genericVisit, suspensionVisits } = initialArrayOfCooperativeVisits(padVisit);

      return {
        ...state,
        loading: false,
        pad,
        padVisit,
        padVisitId,

        selectedData: {
          scheduleImplantation: {},
          dischargePatient: pad.hospitalReleasePrevision,
          scheduleVisits: {
            genericVisit
          },
          suspensionVisits
        }
      };
    }

    case `${TEMPLATE_NAME}_SUBMIT_PENDING`: {
      return {
        ...state,
        isSubmitting: true
      };
    }

    case `${TEMPLATE_NAME}_SUBMIT_REJECTED`: {
      return {
        ...state,
        isSubmitting: false
      };
    }

    case `${TEMPLATE_NAME}_SUBMIT_FULFILLED`: {
      return {
        ...state,
        isSubmitting: false
      };
    }

    case `${TEMPLATE_NAME}_SELECT_AND_UPDATE_DATA`: {
      const newData = action.payload;

      const updateGenericVisit = newData.hasOwnProperty('GenericVisit');
      const updateImplantationVisit = newData.hasOwnProperty('ImplantationVisit');

      const { scheduleImplantation } = state.selectedData;
      const { genericVisit } = state.selectedData.scheduleVisits;

      const genericVisitUpdated = updateGenericVisit ? newData.GenericVisit : genericVisit;
      const implantationVisitUpdated = updateImplantationVisit
        ? newData.ImplantationVisit
        : scheduleImplantation;

      const events = !isEmpty(implantationVisitUpdated.events)
        ? implantationVisitUpdated.events
        : [];

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          scheduleVisits: {
            ...state.selectedData.scheduleVisits,
            genericVisit: [...genericVisitUpdated]
          },
          scheduleImplantation: {
            ...state.selectedData.scheduleImplantation,
            events
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_AUTOMATIC_REPETITION`: {
      const padVisit = action.payload;
      const { genericVisit } = state.selectedData.scheduleVisits;
      const genericVisitUpdated = updateAutomaticRepeat(padVisit, genericVisit);

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          scheduleVisits: {
            ...state.selectedData.scheduleVisits,
            genericVisit: [...genericVisitUpdated]
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_SCHEDULE_MAXIMUM_VISITS`: {
      const { padVisit, isMaximumVisitsScheduled } = action.payload;
      const { genericVisit } = state.selectedData.scheduleVisits;
      const genericVisitUpdated = updateScheduledMaximumVisits(
        padVisit,
        genericVisit,
        isMaximumVisitsScheduled
      );

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          scheduleVisits: {
            ...state.selectedData.scheduleVisits,
            genericVisit: [...genericVisitUpdated]
          }
        }
      };
    }

    case `${TEMPLATE_NAME}_UPDATE_SCHEDULE_PRESCRIPTION`: {
      const { payload: schedulePrescriptions } = action;

      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          schedulePrescriptions
        }
      };
    }

    case `${TEMPLATE_NAME}_HOSPITAL_DISCHARGE`: {
      const hospitalReleasePrevision = action.payload;
      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          hospitalReleasePrevision
        }
      };
    }

    case `${TEMPLATE_NAME}_DISCHARGE_PATIENT`: {
      const dischargePatient = action.payload;
      return {
        ...state,
        selectedData: {
          ...state.selectedData,
          dischargePatient
        }
      };
    }

    case `${TEMPLATE_NAME}_INITIALIZATION_STEPS`: {
      const steps = action.payload;
      return {
        ...state,
        steps
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
